import axios from "axios";
import store from "@/store";
import { getApiUrl } from "@/Utils/api-url-helper";

const REDIRECT_STORAGE_KEY = "olimpiadas_registration_intent";

export const buildRegistrationIntent = ({ contest, sourcePath }) => ({
  slug: contest.slug,
  courseId: contest.courseId,
  returnTo: sourcePath,
});

export const saveRegistrationIntent = (intent) => {
  window.localStorage.setItem(REDIRECT_STORAGE_KEY, JSON.stringify(intent));
};

export const loadRegistrationIntent = () => {
  const raw = window.localStorage.getItem(REDIRECT_STORAGE_KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
};

export const clearRegistrationIntent = () => {
  window.localStorage.removeItem(REDIRECT_STORAGE_KEY);
};

export const isProfileComplete = (user) => {
  if (!user) return false;
  const required = ["dateBirth", "country", "department", "gender"];
  return required.every((field) => Boolean(user[field]));
};

export const fetchCurrentUser = async () => {
  const apiBaseUrl = getApiUrl(import.meta.env.VITE_API_BASE_URL);
  return axios.get(`${apiBaseUrl}/user/me`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });
};

export const enrollInCourse = async (courseId) => {
  const apiBaseUrl = getApiUrl(import.meta.env.VITE_API_BASE_URL);
  return axios.post(
    `${apiBaseUrl}/api/modules/enroll`,
    { course: courseId },
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    }
  );
};

export const runRegistrationFlow = async ({
  contest,
  router,
  onNeedsProfile,
  onRegistered,
  onError,
}) => {
  const isAuthenticated = store.state.auth.isAuthenticated;

  if (!isAuthenticated) {
    const intent = buildRegistrationIntent({
      contest,
      sourcePath: router.currentRoute.fullPath,
    });
    saveRegistrationIntent(intent);
    router.push({
      path: "/v2/auth/login",
      query: { redirect: intent.returnTo },
    });
    return;
  }

  try {
    const response = await fetchCurrentUser();
    const userData = response.data;

    if (!isProfileComplete(userData)) {
      const intent = buildRegistrationIntent({
        contest,
        sourcePath: router.currentRoute.fullPath,
      });
      saveRegistrationIntent(intent);
      onNeedsProfile?.(intent);
      return;
    }

    try {
      await enrollInCourse(contest.courseId);
    } catch (error) {
      if (error?.response?.status !== 400) {
        throw error;
      }
    }

    clearRegistrationIntent();
    onRegistered?.(contest);
  } catch (error) {
    onError?.(error);
  }
};
